"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamPlayerFactory = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var video_client_web_1 = require("@video/video-client-web");
// Only create 1 instance of the VideoClient.
var vc;
var StreamPlayerFactory = /** @class */ (function () {
    function StreamPlayerFactory(user, config, playerConstructor) {
        if (playerConstructor === void 0) { playerConstructor = video_client_web_1.VideoClient; }
        // Store the userId used to create the VideoClient instance so we know if we need to update.
        this._vcUserId = 0;
        this._config = config;
        if (vc === undefined) {
            vc = new playerConstructor({
                userId: user.id.toString(),
                playerOptions: this._getPlayerOptions(),
            });
            this._vcUserId = user.id;
        }
        else if (this._vcUserId !== user.id) {
            vc.updateOptions({
                userId: user.id.toString(),
            });
            this._vcUserId = user.id;
        }
    }
    StreamPlayerFactory.prototype._getConfig = function () {
        return __assign(__assign({}, StreamPlayerFactory._defaultStreamingConfig), this._config);
    };
    StreamPlayerFactory.prototype._getManifestUrl = function (manifestTemplate, performerNickname) {
        // dev ex: https://manifest-server.integ.naiadsystems.com/live/s:mewt.json
        // prod ex: https://manifest-server.naiadsystems.com/live/s:mewt.json
        return manifestTemplate.replace(/\{performerNickname\}/g, performerNickname);
    };
    StreamPlayerFactory.prototype._getPlayerOptions = function () {
        return {
            volume: 0,
            muted: !this._getConfig().audioEnabled,
            bitrate: 1200,
            autoplay: true,
        };
    };
    Object.defineProperty(StreamPlayerFactory.prototype, "streamingAvailable", {
        get: function () {
            return !!this._config;
        },
        enumerable: false,
        configurable: true
    });
    StreamPlayerFactory.prototype.canFadePlayerVolume = function (player) {
        return player && !player.localAudioMuted;
    };
    StreamPlayerFactory.prototype.createPlayer = function (userId, performerNickname, element) {
        if (!this.streamingAvailable) {
            throw new Error("Streaming is not available.");
        }
        var fastManifestTemplate = this._getConfig().fastManifestTemplate;
        var player = vc.requestPlayer(this._getManifestUrl(fastManifestTemplate, performerNickname));
        if (video_client_web_1.adapter.device.isImplements(video_client_web_1.adapter.Feature.CREATE_VIDEO_ELEMENT)) {
            var videoEl = video_client_web_1.adapter.device.createVideoElement();
            player.attachTo(videoEl);
            player.localAudioMuted = false;
            element.appendChild(videoEl);
        }
        return player;
    };
    StreamPlayerFactory._defaultStreamingConfig = {
        fastManifestTemplate: "https://manifest-server.integ.naiadsystems.com/live/s:{performerNickname}.json",
    };
    return StreamPlayerFactory;
}());
exports.StreamPlayerFactory = StreamPlayerFactory;
//# sourceMappingURL=StreamPlayerFactory.js.map